import { render } from "./Check_Person.vue?vue&type=template&id=562e26cd"
import script from "./Check_Person.vue?vue&type=script&lang=js"
export * from "./Check_Person.vue?vue&type=script&lang=js"
script.render = render

export default script